import axios from 'axios';
import { loginreq, getReq,postRed } from './axiosFun';

// 登录接口
export const login = (user) => { return loginreq("POST", "/log/login", user) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return getReq("get", "/wechatuser/selectUserList", {
  limit: params.limit,
  page: params.page,
  name: params.name || '',
  mobile: params.mobile || '',
  gender: params.gender,
  membership: params.membership || ''
}) };
//查看用户订单
export const selectOrderByUser = (params) => { return getReq("get", "/WeChatUser/selectOrderByUser?limit="+
  params.limit+'&page='+params.page+'&userId='+params.userId,{}) };

export const getMyself = (params) => { return getReq("get", "/log/getMyself",{}) };

export const updateMyself = (params) => { return postRed("post", "/log/updateMyself", params) };

//修改用户信息
export const updateWechat = (params) => { return postRed("post", "/WeChatUser/updateWechat",params) };

//删除乘车人
export const delectWeChat = (id) => { return getReq("get", "/wxpay/refund?id="+id,{}) };

/**'
 * 账号学校管理接口
 */
export const selectAllManage = (params) => { return getReq("get", "/manage/selectAllUser?limit="+
  params.limit+'&page='+params.page+'&name='+params.name+'&username='+params.username,{}) };
//新增账号
export const insertManage = (params) => { return postRed("post", "/manage/insert",params) };
//修改
export const updateManage = (params) => { return postRed("post", "/manage/update",params) };
//删除
export const delectManage = (id) => { return getReq("get", "/manage/delect?userId="+id,{}) };

/**
 * 驿站接口
 */
export const selectAllSite = (params) => { return getReq("get", "/site/selectAllSite?limit="+
  params.limit+'&page='+params.page+'&name='+params.name,{}) };
//新增账号
export const insertSite = (params) => { return postRed("post", "/site/insertSite",params) };
//修改
export const updateSite = (params) => { return postRed("post", "/site/updateSite",params) };
//删除
export const deleteSite = (id) => { return getReq("get", "/site/deleteSite?id="+id,{}) };
// 异常接口
export const abnormals = (id) => { return getReq("get", "/ordering/abnormal?id="+id,{}) };


/**
 * 宿舍楼接口
 */
export const selectAllDorm = (params) => { return getReq("get", "/dorm/selectAllDorm?limit="+
  params.limit+'&page='+params.page+'&name='+params.name,{}) };
//新增
export const insertDorm  = (params) => { return postRed("post", "/dorm/insertDorm",params) };
//修改
export const updateDorm  = (params) => { return postRed("post", "/dorm/updateDorm",params) };
//删除
export const deleteDorm  = (id) => { return getReq("get", "/dorm/deleteDorm?id="+id,{}) };


/**
 * 优惠卷接口
 */
export const couponSelectAll = (params) => { return getReq("get", "/coupon/selectAll?limit="+
  params.limit+'&page='+params.page+'&name='+params.name+'&rule='+params.rule+'&limitations='+params.limitations,{}) };
//新增优惠卷
  export const insertCoupon  = (params) => { return postRed("post", "/coupon/insert",params) };
//删除优惠卷规则
  export const delectCoupon  = (id) => { return getReq("get", "/coupon/delect?id="+id,{}) };
//根据用户手机号发放优惠卷
  export const insertCouponByPhone  = (params) => { return getReq("get", "/coupon/insertCouponByPhone?userPhone="+params.userPhone+'&denom='+params.denom+'&type='+params.type,{}) };
//发放
  export const grantCoupon  = (params) => { return getReq("get", "/coupon/grant?id="+params.id+'&distribute='+params.distribute+'&effective='+params.effective,{}) };

/**
 * 快递订单管理
 */
export const selectAllOrdering = (params) => { return getReq("get", "/ordering/selectAllOrdering?limit="+
  params.limit+'&page='+params.page+'&userPhone='+params.userPhone+'&siteName='+params.siteName+'&orderStatus='+params.orderStatus+'&orderNumber='+params.orderNumber,{}) };
//批量送达
export const batchDelivery = (params) => { return postRed("post", "/ordering/batchDelivery",params) };
//批量接单
export const takingOrders = (params) => { return postRed("post", "/ordering/takingOrders",params) };
//修改快递价格
export const abnormal = (params) => { return getReq("get", "/ordering/updateExpress?express="+params.express,{}) };

//上楼价格
export const UpstairsPrice = (upstairsPrice) => { return getReq("get", "/ordering/updateUpstairsPrice?upstairsPrice="+upstairsPrice,{}) };

/**
 * 查看广告
 */
//列表
export const advertisement = (params) => { return getReq("get", "/advertisement/select",{}) };

export const advertisementUpdate = (params) => { return postRed("post", "/advertisement/update",params) };

/**
 * 车辆管理
 */
//列表
export const vehicleManagement = (params) => { return getReq("get", "/VehicleManagement/selectAllVehicle?limit="+
  params.limit+'&page='+params.page+'&brand='+params.brand+'&fixId='+params.fixId+'&identify='+params.identify
  +'&isAssociation='+params.isAssociation+'&licenseplate='+params.licenseplate,{}) };
//新增
export const insertVehicle = (params) => { return postRed("post", "/VehicleManagement/insert",params) };
//修改
export const updateVehicle = (params) => { return postRed("post", "/VehicleManagement/update",params) };
//删除
export const delectVehicle = (vehicleId) => { return getReq("get", "/VehicleManagement/delectVehicleForId?vehicleId="+ vehicleId,{}) };
//年审车辆
export const goInspectVehicle = (vehicleId) => { return getReq("get", "/VehicleManagement/goInspectAnnually?vehicleId="+ vehicleId,{}) };




// WEBPACK FOOTER //
// ./src/api/userMG.js